import { useLayoutEffect, useState } from 'react';

function useWindowSize() {
  const [size, setSize] = useState([0, 0]);

  useLayoutEffect(() => {
    function updateSize() {

      if (size[0] !== window.innerWidth || size[1] !== window.innerHeight) {
        setSize([window.innerWidth, window.innerHeight]);
      }
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, [size]);

  return size;
}

export default useWindowSize;
